<template>
    <transition name="slide">
        <div class="bg-surface-secondary w-100">
            <header class="bg-surface-primary border-bottom">
                <div class="container-fluid py-3">
                    <div class="row align-items-center">
                        <div class="col">
                            <div class="d-flex align-items-center gap-4">
                                <div>
                                    <button type="button" class="btn-close text-xs" @click="$router.go(-1)"></button>
                                </div>
                                <div class="vr opacity-20 my-1"></div>
                                <div>
                                    <h1 class="h4 ls-tight">Paquete - {{ data.type }}{{ data.id }}</h1>
                                    <p class="text-sm text-muted mb-0">Tu paquete con la descripción
                                        <v-tooltip bottom class="mx-1">
                                            <template v-slot:activator="{ on, attrs }">
                                                <b v-bind="attrs" v-on="on" class="nowrap" v-if="Array.isArray(data.description)">
                                                    {{ data.description[0] }} ...
                                                </b>
                                            </template>
                                            <small><div v-for="(description, key) in  data.description" :key="key">{{ description }}</div></small>
                                        </v-tooltip>
                                    se encuentra en estado: <b>{{ data.state ? data.state.name : '' }}</b>.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
            <main class="py-6 bg-surface-secondary">
                <div class="container-fluid vstack gap-5">
                    <div class="w-100 pt-5" v-if="loading">
                        <div class="text-center">
                            <div class="spinner-border text-primary" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                    </div>
                    <div class="row" v-else>
                        <div class="col-lg-6">
                            <div class="form-group mb-2 d-flex align-items-center">
                                <small class="input-title" style="width: 140px;">Valor: </small>
                                <div class="ml-2" style="width: calc(100% - 140px);">
                                    <input type="text" readonly class="form-control form-control-sm text-muted bg-white" style="font-size: 11px; height: 31px; display: flex; align-items: center;" :value="Number(data.value || 0).toFixed(2)">
                                </div>
                            </div>
                            <div class="form-group mb-2 d-flex align-items-center">
                                <small class="input-title" style="width: 140px;">Remitente: </small>
                                <div class="ml-2" style="width: calc(100% - 140px);">
                                    <input type="text" readonly class="form-control form-control-sm text-muted bg-white" style="font-size: 11px; height: 31px; display: flex; align-items: center;" :value="data.shipper">
                                </div>
                            </div>
                            <div class="form-group mb-2 d-flex align-items-center">
                                <small class="input-title" style="width: 140px;">Peso: </small>
                                <div class="ml-2" style="width: calc(100% - 140px);">
                                    <input type="text" readonly class="form-control form-control-sm text-muted bg-white" style="font-size: 11px; height: 31px; display: flex; align-items: center;" :value="Number(data.weight || 0).toFixed(2)">
                                </div>
                            </div>
                            <div class="form-group mb-2 d-flex align-items-center">
                                <small class="input-title" style="width: 140px;">Estado: </small>
                                <div class="ml-2" style="width: calc(100% - 140px);">
                                    <input type="text" readonly class="form-control form-control-sm text-muted bg-white" style="font-size: 11px; height: 31px; display: flex; align-items: center;" :value="data.state.name">
                                </div>
                            </div>
                            <div class="form-group mb-2 d-flex align-items-center">
                                <small class="input-title" style="width: 140px;">Descripción: </small>
                                <div class="ml-2" style="width: calc(100% - 140px);">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <div v-bind="attrs" v-on="on">
                                                <input type="text" readonly class="form-control form-control-sm text-muted bg-white" style="font-size: 11px; height: 31px; display: flex; align-items: center;" v-model="data.description">
                                            </div>
                                        </template>
                                        <small><div v-for="(description, key) in  data.description" :key="key">{{ description }}</div></small>
                                    </v-tooltip>
                                </div>
                            </div>
                            <div class="form-group mb-2 d-flex align-items-center">
                                <small class="input-title" style="width: 140px;">Tracking: </small>
                                <div class="ml-2" style="width: calc(100% - 140px);">
                                    <input type="text" readonly class="form-control form-control-sm text-muted bg-white" style="font-size: 11px; height: 31px; display: flex; align-items: center;" :value="data.tracking">
                                </div>
                            </div>
                            <div class="form-group mb-2 d-flex align-items-center">
                                <small class="input-title" style="width: 140px;">Impuesto: </small>
                                <div class="ml-2" style="width: calc(100% - 140px);">
                                    <input type="text" readonly class="form-control form-control-sm text-muted bg-white" style="font-size: 11px; height: 31px; display: flex; align-items: center;" :value="data.tax ? Number((data.tax.value*100) || 0).toFixed(2) + '%' : ''">
                                </div>
                            </div>
                            <div class="form-group mb-2 d-flex align-items-center">
                                <small class="input-title" style="width: 140px;">Creado: </small>
                                <div class="ml-2" style="width: calc(100% - 140px);">
                                    <input type="text" readonly class="form-control form-control-sm text-muted bg-white" style="font-size: 11px; height: 31px; display: flex; align-items: center;" :value="data.created_at | DATE">
                                </div>
                            </div>
                            <div class="form-group mb-2 d-flex align-items-center" v-if="data.exemption">
                                <small class="input-title" style="width: 140px;">Estado de ExenciónSolicitada: </small>
                                <div class="ml-2" style="width: calc(100% - 140px);">
                                    <input type="text" readonly class="form-control form-control-sm text-muted bg-white" style="font-size: 11px; height: 31px; display: flex; align-items: center;" :value="data.exemption | EXEMPTION">
                                </div>
                            </div>
                            <div>
                                <div class="form-group mb-2 d-flex align-items-center">
                                    <small class="input-title" style="width: 140px;">Archivos Adjuntos: </small>
                                    <div class="ml-2" style="width: calc(100% - 140px);">
                                        <div class="py-3"></div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-2 col-sm-3 col-4" v-for="(item, index) in data.files">
                                        <a :href="`${item.path}`" target="_blank" rel="noopener noreferrer">
                                            <img :src="`${item.path}`" class="img-fluid" v-if="item.type != 'pdf'">
                                            <img :src="pdf" class="img-fluid" v-else>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="card">
                                <div class="card-body">
                                    <billing v-if="data.invoice" :print="false"/>
                                    <div v-else>Su paquete aun no cuenta con factura</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    </transition>
</template>
<script>
import Billing from '../forms/invoice/Billing'
import pdf from '@/assets/img/pdf.png'
export default {
    components: { Billing },
    data() {
        return {
            loading: true,
            data: {},
            id: this.$route.params.id,
            pdf
        }
    },
    mounted() {
        this.INIT()
    },
    methods: {
        INIT: function () {
            let vue = this
            axios({ url: '/clients/packages/' + vue.id, method: 'GET' })
                .then((resp) => {
                    vue.data = resp.data
                })
                .catch((err) => {
                   let message = err.response ? err.response.data.message : err.message
                        vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                })
                .finally((resp) => {
                    vue.loading = false
                })
        }
    },
}
</script>